import {logMessage} from "../taskpane";
import 'cross-fetch/polyfill';

/**
 * The add-in API of the Platform office front. It exchanges a nested app
 * authentication token for the same office handoff as the sign-in dialog.
 */
export class PlatformApi
{

    /**
     * @param platformUrl
     * @param accessToken
     * @returns {Promise<Array<{officeUuid: string, name: string, clusterName: string, isActive: boolean}>>}
     */
    static async getOffices(platformUrl, accessToken)
    {
        logMessage('PlatformApi.getOffices()');
        const response = await fetch(platformUrl + '/office-addin/offices', {
            method: 'GET',
            credentials: 'omit',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
            },
        });

        logMessage('-> Received response with status ' + response.status);
        if (response.status !== 200) {
            throw new Error('Platform offices request failed with status ' + response.status);
        }

        const json = await response.json();

        return Array.isArray(json.offices) ? json.offices : [];
    }


    /**
     * @param platformUrl
     * @param accessToken
     * @param officeUuid
     * @param callbackUrl
     * @param state
     * @returns {Promise<{code: string, extOfficeUuid: string, clusterUrl: string, state: string}>}
     */
    static async createHandoff(platformUrl, accessToken, officeUuid, callbackUrl, state)
    {
        logMessage('PlatformApi.createHandoff()');
        const response = await fetch(platformUrl + '/office-addin/offices/' + encodeURIComponent(officeUuid) + '/handoff', {
            method: 'POST',
            credentials: 'omit',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({addinCallbackUrl: callbackUrl, state: state}),
        });

        logMessage('-> Received response with status ' + response.status);
        if (response.status !== 200) {
            throw new Error('Platform handoff request failed with status ' + response.status);
        }

        // The Platform returns the callback URL of the dialog flow; its query holds the handoff.
        const json = await response.json();
        const params = new URL(json.redirectUrl).searchParams;

        return {
            code: params.get('code'),
            extOfficeUuid: params.get('extOfficeUuid'),
            clusterUrl: params.get('clusterUrl'),
            state: params.get('state'),
        };
    }

}
